import { Nav, Tab } from "react-bootstrap";
import { IEpaCorrespondenceDetails } from "../../../api/IEpaCorrespondence";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import { EdenMessagesGrid } from "../../../leap-components/EdenMessages/EdenMessagesGrid";
import { EdenMessagesGridType } from "../../../leap-components/EdenMessages/EdenMessagesGridProps";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  epaCorrespondence: IEpaCorrespondenceDetails;
  licenceProfile: ILicenceProfile;
}

interface EpaCorrespondenceProps {
  epaCorrespondence: IEpaCorrespondenceDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  licenceProfile,
  epaCorrespondence,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="messages">Messages</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={epaCorrespondence.epainitiatedcorrespondenceid}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="messages">
          <EdenMessagesGrid
            edenMessagesType={EdenMessagesGridType.RegardingBasedEdenMessages}
            profileNumber={licenceProfile.profileNo}
            regardingObjectId={epaCorrespondence.epainitiatedcorrespondenceid}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  epaCorrespondence,
  licenceProfile,
}: EpaCorrespondenceProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      epaCorrespondence={epaCorrespondence}
      licenceProfile={licenceProfile}
    />
  );

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
